import { lazy, Suspense, useEffect, useState } from "react"
import Footer from "../../components/Footer"
import CategoriesCard from "../../components/categories_list/CategoriesCard"
import CategoriesList from "../../components/categories_list/CategoriesList"
import PageLayout from "../../components/ui/PageLayout"
import Hero from "./components/Hero"
import HomeAds from "./components/HomeAds"

// The slider pulls in the Swiper library (~90 KB): load it separately so the rest of the
// home page (hero, categories, ads) doesn't wait for it
const FeaturedCategoriesSlider = lazy(() => import("./components/FeaturedCategoriesSlider"))

// Same skeleton the slider shows while its categories load, so nothing jumps
const SliderSkeleton = () => (
    <div className="w-full p-3">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
            {[...Array(5)].map((_, index) => (
                <div key={index} className="flex flex-col items-center p-3 rounded-xl bg-surface-tertiary animate-pulse">
                    <div className="w-12 h-12 rounded-full bg-solid-100 mb-2" />
                    <div className="h-3 w-16 bg-solid-100 rounded-full" />
                </div>
            ))}
        </div>
    </div>
)

// Tablets and computers (768px+). Phones get the category strip instead of the slider,
// so they don't download the slider at all.
const useIsWideScreen = () => {
    const query = "(min-width: 768px)"
    const [isWide, setIsWide] = useState(() => window.matchMedia(query).matches)
    useEffect(() => {
        const media = window.matchMedia(query)
        const onChange = () => setIsWide(media.matches)
        media.addEventListener("change", onChange)
        return () => media.removeEventListener("change", onChange)
    }, [])
    return isWide
}

const Home = () => {
    const isWideScreen = useIsWideScreen()
    return (
        <div>
            <Hero />
            <PageLayout>
                {isWideScreen && (
                    <div className="max-w-[90rem] mx-auto">
                        <Suspense fallback={<SliderSkeleton />}>
                            <FeaturedCategoriesSlider />
                        </Suspense>
                    </div>
                )}
                <div className="pt-0 md:pt-12 grid grid-cols-1 md:grid-cols-7 gap-3 md:gap-6 lg:max-w-[90rem] mx-auto relative">
                    {/* Sidebar - CategoriesList for larger screens - with fixed positioning */}
                    <div className="hidden md:block col-span-2">
                        <div className="sticky top-[6rem] max-h-[calc(100vh-2rem)] overflow-y-auto pb-4">
                            <CategoriesList />
                        </div>
                    </div>

                    {/* Phones: one row of categories */}
                    <div className="block md:hidden">
                        <CategoriesCard />
                    </div>

                    {/* HomeAds content */}
                    <div className="col-span-full px-2 md:col-span-5 max-w-full">
                        <HomeAds />
                    </div>
                </div>
            </PageLayout>
            <Footer />
        </div>
    )
}

export default Home
